import angular from 'angular';
import { loaderService, reportsDataService, ssDialogService } from 'app/services';
import { alerts, actionIcon, confirmDialog } from 'app/components/global';
import reportPackageReports from './reportPackageReports';
import editReportPackageDialog from '../../dialog.editReportPackage';
import directive from './report-package.directive';
import controller from './report-package.controller';

export default angular
  .module('app.components.reports.packageReports.reportPackage', [
    loaderService,
    reportsDataService,
    ssDialogService,
    alerts,
    actionIcon,
    confirmDialog,
    editReportPackageDialog,
    reportPackageReports,
  ])
  .directive('prReportPackage', directive)
  .controller('PRReportPackageController', controller).name;

console.log('app.components.reports.packageReports.reportPackage created');
